module.exports = __webpack_public_path__ + "static/media/ico_right.6e829080.svg";